var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageTransferArgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42.9997,
    height: 43,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5007 31.9167V27.75M17.334 29.8333V27.75M25.6673 29.8333V27.75",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5202 26.7085C30.4076 26.5413 31.0771 26.262 31.6152 25.7961C32.9577 24.6337 32.9577 22.7628 32.9577 19.021C32.9577 15.2792 32.9577 13.4083 31.6152 12.2459C30.2729 11.0835 28.1122 11.0835 23.791 11.0835H19.2077C14.8865 11.0835 12.7259 11.0835 11.3834 12.2459C10.041 13.4083 10.041 15.2792 10.041 19.021C10.041 22.7628 10.041 24.6337 11.3834 25.7961C11.9215 26.262 12.5911 26.5413 13.4785 26.7085",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2722 19.4165H28.2617",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.741 19.4165H14.7305",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.625 22.0128C24.1267 22.9539 23.22 23.5833 22.1842 23.5833C20.6115 23.5833 19.3365 22.1324 19.3365 20.3426V18.4907C19.3365 16.7009 20.6115 15.25 22.1842 15.25C23.22 15.25 24.1267 15.8794 24.625 16.8206M18.375 19.4167H22.4616",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageTransferArgent);
export default __webpack_public_path__ + "static/media/imageTransferArgent.06b1e230a4d90ec23bb6edafc5a96609.svg";
export { ForwardRef as ReactComponent };